import { sortMeasurements } from './chart';
/** Letzte (chronologisch neueste) Messung mit einem gesetzten Wert des jeweiligen Feldes. */
export function latestValue(measurements, key) {
    const list = sortMeasurements(measurements).filter(e => e[key] !== null);
    return list.length ? list[list.length - 1] : null;
}
export function findByDate(measurements, date) {
    return measurements.find(e => e.date === date) ?? null;
}
